<template>

  <v-dialog
    :model-value="props.modelValue"
    max-height="800"
    max-width="1200"
    @after-leave="$emit('after-leave')"
  >
    <v-card class="rounded-lg">
      <v-card-title
        class="popUpCardTitle pa-4 d-flex justify-space-between align-center"
      >
        <span class="title-popup">{{ props.titlePopUp }}</span>
        <v-btn icon variant="text" size="small" @click="onExit">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-sheet class="pa-6 d-flex justify-space-between align-center">
        <p>{{ subtitlePopUp }}</p>
        <FilterComponent
          v-model:filters="filtersState"
          :show-chart="false"
          :show-table="false"
          :show-search="true"
          :show-filter="false"
          :show-refresh="false"
          @submit:search="searchItems($event)"
        />
      </v-sheet>

      <v-sheet class="pa-6">
        <rb-loader v-if="isLoading" v-model="rows" :contained="true" />
        <TableInsights
          :headers="headers"
          :items="rows"
          :show-total="false"
          v-model:page="page"
          v-model:itemsPerPage="ipp"
          :items-per-page-options="[5,10,25,50]"
          :highlight-index="1"
        />
      </v-sheet>
    </v-card>


  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits, watch, ref} from 'vue';
import { PostWithJson } from '@/ai_studio/http/http.js';
import FilterComponent from '../FilterComponent.vue';
import TableInsights from '../TableInsights.vue';
import RbLoader from '@/ai_studio/components/common/RbLoader.vue';

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  titlePopUp: { type: String, default: 'Detalhes' },
  subtitlePopUp: { type: String, default: '' },
  url: { type: String, required: true },
  payload: { type: Object, default: () => {}, required: true },
  headers: { type: Array, default: () => [] },
  rowsKeys: { type: Array, default: () => [] },
});

const data = ref(null);
const ipp = ref(5);
const page = ref(1);
const filtersState = ref({});
const rows = ref([]);
const isLoading = ref(false);

const emit = defineEmits(['update:modelValue', 'after-leave']);

function onExit() {
  page.value = 1
  emit('update:modelValue', false);
}
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal === true) {
      fetchData();
    }
  }
)
const fetchData= async () =>  {
  const payload = props.payload || {};
  try {
    isLoading.value = true;
    const response = await PostWithJson(props.url, JSON.stringify(payload));
    if (response) {
      data.value = response;
      buildRowsFromData();
    } else {
      data.value = [];
      rows.value = [];
    }
  } catch (error) {
    isLoading.value = false;
    console.error('Erro ao buscar dados:', error);
  } finally {
    isLoading.value = false;
  }
}

function buildRowsFromData() {
  const items = Array.isArray(data.value?.dados) ? data.value.dados : [];
  const urlCrm = data.value?.urlCrm || '';

  const keys = Array.isArray(props.rowsKeys) ? props.rowsKeys : [];

  rows.value = items.map((row) => {
    const mappedRow = {};

    keys.forEach((key) => {
      if (key === 'probabilidade') {
        const prob = Number(row.probabilidade ?? 0);
        mappedRow.probabilidade = Math.max(0, Math.min(100, prob));
        return;
      }

      if (key === 'nome') {
        const personUrl = row.pessoaprincipal_id
          ? `${urlCrm}contato/${row.pessoaprincipal_id}`
          : null;

        mappedRow.nome = personUrl
          ? { name: row.nome, url: personUrl }
          : row.nome;

        return;
      }

      mappedRow[key] = row[key];
    });

    return mappedRow;
  });
}


function searchItems(searchTerm) {
  if(!searchTerm) return buildRowsFromData();
  rows.value = rows.value.filter(row => {
    return Object.values(row).some(val => {
      if (typeof val === 'object' && val !== null) {
        return val.name.toString().toLowerCase().includes(searchTerm.toLowerCase());
      }
      return val.toString().toLowerCase().includes(searchTerm.toLowerCase());
    });
  });
}

</script>

<style>
.popUpCardTitle {
  background-color: rgb(var(--v-theme-neutral-95));
  color: rgb(var(--v-theme-neutral-35));
  font-size: 16px;
  font-weight: 500;
  padding: 4px 16px 4px 32px !important;
}
</style>
